/**
 * <ReportHero /> — the top of the Discovery report. Big company identity +
 * industry + a single one-line summary, generous whitespace, restraint.
 *
 * The 56px title is the company NAME when the caller has one (org embed
 * already does). Domain is subtitle/meta — never the headline when a name
 * is present. Minutes / leak copy below this hero are hypothesized from
 * public info, so the banner is always on.
 */

export interface HeroEnrichment {
  status: string;
  domain: string | null;
  industry: string | null;
  size: string | null;
  founded: string | null;
  hqLocation: string | null;
  homepageFetched: boolean;
}

export const HYPOTHESIZED_PROCESS_COPY =
  'This is a hypothesized process from public info, not from the call. Confirm before quoting minutes or ROI.';

export default function ReportHero({
  processName,
  enrichment,
  industryLabel,
  companySummary,
  companyName,
}: {
  processName: string;
  enrichment: HeroEnrichment;
  industryLabel: string;
  companySummary: string;
  companyName?: string | null;
}) {
  const name = companyName?.trim() || enrichment.domain || 'This company';
  const domainMeta = companyName?.trim() && enrichment.domain ? enrichment.domain : null;
  const facts = [domainMeta, industryLabel, enrichment.size ? `${enrichment.size} employees` : null, enrichment.hqLocation]
    .filter(Boolean)
    .join('  ·  ');

  return (
    <header className="se-hero">
      <div className="se-hero__eyebrow">Discovery report · {processName}</div>
      <h1 className="se-hero__name">{name}</h1>
      {facts && <div className="se-hero__facts">{facts}</div>}
      <p className="se-hero__summary">{companySummary}</p>
      <div className="se-note se-note--info" role="status">
        {HYPOTHESIZED_PROCESS_COPY}
      </div>
    </header>
  );
}
